var window=global;var $CLJS=require("./cljs_env");require("./cljs_env.js");require("./cljs.core.js");require("./shadow.js.shim.module$ttag.js");require("./clojure.string.js");
'use strict';